import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Download } from "lucide-react";
import { apiConfig } from "../config/api.config";

export default function Piip() {
  const navigate = useNavigate();
  const [dependencias, setDependencias] = useState([]);
  const [dependencia, setDependencia]   = useState("");
  const [descargando, setDescargando]   = useState(false);
  const [error, setError]               = useState(null);

  // Cargar dependencias disponibles
  useEffect(() => {
    fetch(apiConfig.getUrl("/api/hacienda/piip/dependencias/"), { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data.dependencias)) setDependencias(data.dependencias);
      })
      .catch(() => {});
  }, []);

  const handleDescargar = async () => {
    setDescargando(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (dependencia) params.set("dependencia", dependencia);

      const url = apiConfig.getUrl("/api/hacienda/piip/exportar/") +
        (params.toString() ? "?" + params.toString() : "");

      const res = await fetch(url, { credentials: "include" });
      if (!res.ok) throw new Error("Error al generar el archivo");

      const blob = await res.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PIIP_${dependencia || "Todos"}_${new Date().toISOString().slice(0,10)}.xlsx`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (e) {
      setError(e.message);
    } finally {
      setDescargando(false);
    }
  };

  const card = {
    background: "#fff",
    borderRadius: "16px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    padding: "2rem",
    marginBottom: "1.5rem",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6", padding: "2rem 1.5rem" }}>
      <div style={{ maxWidth: "600px", margin: "0 auto" }}>

        {/* Botón volver */}
        <button type="button" onClick={() => navigate("/hacienda-presupuesto")}
          style={{ background: "#e5e7eb", color: "#111827", border: "none",
            borderRadius: "10px", padding: "0.7rem 1rem",
            cursor: "pointer", fontWeight: 600, marginBottom: "1.5rem" }}>
          ← Volver a Hacienda
        </button>

        {/* Título */}
        <div style={{ marginBottom: "1.5rem" }}>
          <h1 style={{ margin: 0, color: "#163b8c", fontSize: "2rem", fontWeight: 800 }}>
            PIIP
          </h1>
          <p style={{ marginTop: "0.5rem", color: "#6b7280" }}>
            Plan Indicativo de Inversión Pública — Exportación de registros presupuestales y distribución por indicador.
          </p>
        </div>

        {/* Card descarga */}
        <div style={card}>
          <h2 style={{ margin: "0 0 1.5rem", color: "#163b8c", fontSize: "1.1rem", fontWeight: 700 }}>
            Descargar informe PIIP
          </h2>

          {/* Filtro dependencia */}
          <div style={{ marginBottom: "1.5rem" }}>
            <label style={{ display: "block", fontWeight: 600, color: "#374151",
              fontSize: "0.9rem", marginBottom: "0.5rem" }}>
              Filtrar por dependencia
            </label>
            <select
              value={dependencia}
              onChange={e => setDependencia(e.target.value)}
              style={{ width: "100%", padding: "0.75rem 1rem",
                borderRadius: "10px", border: "1px solid #d1d5db",
                fontSize: "0.95rem", color: "#111827", background: "#fff",
                cursor: "pointer", outline: "none" }}>
              <option value="">Todas las dependencias</option>
              {dependencias.map(dep => (
                <option key={dep} value={dep}>{dep}</option>
              ))}
            </select>
          </div>

          {/* Info del archivo */}
          <div style={{ background: "#f0f6ff", borderRadius: "10px",
            padding: "1rem 1.2rem", marginBottom: "1.5rem",
            fontSize: "0.87rem", color: "#374151", lineHeight: 1.8 }}>
            <div><strong>Hoja 1 — RP:</strong> Registros presupuestales aprobados con NIT, nombre, dependencia y valores.</div>
            <div><strong>Hoja 2 — Indicadores:</strong> Distribución del valor de cada RP por indicador presupuestal y porcentaje.</div>
            <div><strong>Hoja 3 — Resumen:</strong> Vista general de los datos distribuidos por indicador.</div>

          </div>

          {/* Error */}
          {error && (
            <div style={{ background: "#fef2f2", border: "1px solid #fca5a5",
              borderRadius: "10px", padding: "0.85rem 1rem",
              color: "#991b1b", fontSize: "0.9rem", marginBottom: "1rem" }}>
              ⚠️ {error}
            </div>
          )}

          {/* Botón descargar */}
          <button
            type="button"
            onClick={handleDescargar}
            disabled={descargando}
            style={{ width: "100%", display: "flex", alignItems: "center",
              justifyContent: "center", gap: "0.6rem",
              background: descargando ? "#93c5fd" : "#163b8c",
              color: "#fff", border: "none", borderRadius: "12px",
              padding: "0.95rem 1.5rem", fontSize: "1rem",
              fontWeight: 700, cursor: descargando ? "not-allowed" : "pointer",
              transition: "background 0.2s ease",
              boxShadow: "0 4px 14px rgba(22,59,140,0.25)" }}>
            <Download size={20} />
            {descargando ? "Generando archivo..." : "Descargar PIIP (.xlsx)"}
          </button>
        </div>

      </div>
    </div>
  );
}